// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f3d6ff68","453":"c9710dc7"}[chunkId] + ".chunk.js";
};